function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'fast-deep-equal';
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import debounce from 'debounce';
import { DEFAULT_ZOOM, MARKER_IMAGE_SRC, MARKER_IMAGE_STYLE, CIRCLE_IMAGE_SRC, CIRCLE_IMAGE_STYLE } from "../../constants";
import { getMapOptions } from "../../utils/getMapOptions";
import { GoogleMapMarker } from "../GoogleMapMarker";
import { adaptENSWtoNESW } from "./utils/adaptENSWtoNESW";
import { getCenterFromBounds } from "./utils/getCenterFromBounds";
import { adaptNESWtoENSW } from "./utils/adaptNESWtoENSW";
import { getCenter } from "./utils/getCenter";
import { getZoomedState } from "./utils/getZoomedState";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      areBoundsChanged: false,
      areBoundsChangedProgramatically: false,
      bounds: null,
      center: null,
      isDragged: false,
      isZoomed: false,
      size: null,
      zoom: DEFAULT_ZOOM
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var bounds = _this.props.bounds;
      if (!bounds) return;

      _this.setState({
        bounds: adaptENSWtoNESW(bounds),
        center: getCenterFromBounds(bounds)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (_ref) {
      var previousControlledBounds = _ref.bounds;
      var size = _this.state.size;
      var controlledBounds = _this.props.bounds;
      if (isEqual(previousControlledBounds, controlledBounds)) return;

      var _fitBounds = fitBounds(adaptENSWtoNESW(controlledBounds), size),
          center = _fitBounds.center,
          newBounds = _fitBounds.newBounds,
          zoom = _fitBounds.zoom;

      _this.setState({
        areBoundsChangedProgramatically: true,
        bounds: newBounds,
        center: center,
        zoom: zoom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref2) {
      var bounds = _ref2.bounds,
          center = _ref2.center,
          size = _ref2.size,
          zoom = _ref2.zoom;
      var onBoundsChange = _this.props.onBoundsChange;
      var _this$state = _this.state,
          areBoundsChanged = _this$state.areBoundsChanged,
          isDragged = _this$state.isDragged,
          isZoomed = _this$state.isZoomed;

      if (areBoundsChanged) {
        onBoundsChange(adaptNESWtoENSW(bounds), isZoomed || isDragged);

        _this.setState({
          areBoundsChanged: false,
          areBoundsChangedProgramatically: false,
          isDragged: false,
          isZoomed: false
        });
      }

      if (!_this.props.bounds) return;

      _this.setState({
        areBoundsChanged: true,
        bounds: bounds,
        center: center,
        size: size,
        zoom: zoom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleApiLoaded", function (_ref3) {
      var map = _ref3.map,
          maps = _ref3.maps;
      var onApiLoad = _this.props.onApiLoad;
      if (onApiLoad) onApiLoad({
        map: map,
        maps: maps
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", debounce(function () {
      _this.setState({
        isDragged: true
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleZoomAnimationEnd", function () {
      return _this.setState(getZoomedState);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          apiKey = _this$props.apiKey,
          isShowingExactLocation = _this$props.isShowingExactLocation,
          isShowingApproximateLocation = _this$props.isShowingApproximateLocation,
          latitude = _this$props.latitude,
          longitude = _this$props.longitude,
          markers = _this$props.markers;
      var _this$state2 = _this.state,
          bounds = _this$state2.bounds,
          zoom = _this$state2.zoom;
      var center = getCenter(_this.state.center, latitude, longitude);
      if (!center) return null;
      return React.createElement(GoogleMapReact, {
        bootstrapURLKeys: {
          key: apiKey
        },
        bounds: bounds,
        center: center,
        onChange: _this.handleChange,
        onDrag: _this.handleDrag,
        onGoogleApiLoaded: _this.handleApiLoaded,
        onZoomAnimationEnd: _this.handleZoomAnimationEnd,
        options: getMapOptions(),
        ref: _this.createRef,
        zoom: zoom
      }, !!isShowingExactLocation && React.createElement(GoogleMapMarker, {
        imageSrc: MARKER_IMAGE_SRC,
        lat: latitude,
        lng: longitude,
        style: MARKER_IMAGE_STYLE
      }), !!isShowingApproximateLocation && React.createElement(GoogleMapMarker, {
        imageSrc: CIRCLE_IMAGE_SRC,
        lat: latitude,
        lng: longitude,
        style: CIRCLE_IMAGE_STYLE
      }), markers.map(function (_ref4) {
        var component = _ref4.component,
            key = _ref4.key,
            latitude = _ref4.latitude,
            longitude = _ref4.longitude;
        return React.cloneElement(component, {
          key: key,
          lat: latitude,
          lng: longitude,
          seLat: latitude + 1000,
          seLng: longitude + 1000
        });
      }));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'GoogleMapReact';
Component.defaultProps = {
  bounds: null,
  latitude: null,
  longitude: null,
  onApiLoad: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  apiKey: PropTypes.string.isRequired,
  bounds: PropTypes.shape({
    east: PropTypes.number.isRequired,
    north: PropTypes.number.isRequired,
    south: PropTypes.number.isRequired,
    west: PropTypes.number.isRequired
  }),
  isShowingApproximateLocation: PropTypes.bool.isRequired,
  isShowingExactLocation: PropTypes.bool.isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  markers: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.node.isRequired,
    key: PropTypes.string.isRequired,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  })).isRequired,
  onApiLoad: PropTypes.func,
  onBoundsChange: PropTypes.func.isRequired
} : {};